import {
  
  ADD_POINTS,
  SET_TOTAL_POINTS,
  SET_LAST_EARNED_POINTS
} from './notificacionesTypes';


export const addPoints = (valor) => ({
  type: ADD_POINTS,
  payload: valor
});

export const setTotalPoints = (valor) => ({
  type: SET_TOTAL_POINTS,
  payload: valor,
});
export const setLastEarnedPoints = (valor) => ({
  type: SET_LAST_EARNED_POINTS,
  payload: valor,
}); 
